import { useEffect } from "react";
import Navbar from "./navbar.js";
import Footer from "./footer.js";

export default function Layout({ children }) {
  useEffect(() => {
    const backToTopBtn = document.getElementById("backToTop");

    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        backToTopBtn.style.display = "flex"; // Bootstrap 按鈕用 flex 置中
      } else {
        backToTopBtn.style.display = "none";
      }
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    // 加入事件監聽
    window.addEventListener("scroll", toggleVisibility);
    backToTopBtn.addEventListener("click", scrollToTop);

    // 清理事件，避免記憶體洩漏
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      backToTopBtn.removeEventListener("click", scrollToTop);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        {children}
        <a
          href="https://page.line.me/vtz1908l?openQrModal=true"
          className="customer-service-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-line"></i> LINE客服
        </a>
        <a
          href="./consult"
          className="customer-service-btn2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-search"></i> 免費評估
        </a>
        <button
          id="backToTop"
          className="btn rounded-circle"
          title="回到最上方"
        >
          <i class="fa-duotone fa-solid fa-angles-up"></i>
        </button>
      </main>
      <Footer />
    </>
  );
}
